import {TimeSlotModel, TimeSlotViewModel} from '@core/models';

const IST_OFFSET_MS = (5 * 60 + 30) * 60 * 1000;

/** Fallback while the first book-later-slots response is in flight. */
export const DEFAULT_ADVANCE_BOOKING_DAYS = 90;

/** Whole days from today through `lastDate`. 0 means today only. */
export function normalizeMaxAdvanceDays(value: unknown): number {
  if (typeof value !== 'number' || !Number.isInteger(value) || value < 0) {
    return DEFAULT_ADVANCE_BOOKING_DAYS;
  }
  return value;
}

export function calendarDateInIndia(date: Date): string {
  return new Intl.DateTimeFormat('en-CA', {timeZone: 'Asia/Kolkata'}).format(date);
}

/** IST calendar day + minutes from midnight → ISO instant (matches book-later grid). */
export function istSlotStartIso(calendarDate: Date, minutesFromMidnight: number): string {
  const dateStr = calendarDateInIndia(calendarDate);
  const [year, month, day] = dateStr.split('-').map(Number);
  const start = new Date(
    Date.UTC(year, month - 1, day) - IST_OFFSET_MS + minutesFromMidnight * 60_000,
  );
  return start.toISOString();
}

export function minutesInIndia(iso: string): number {
  const parts = new Intl.DateTimeFormat('en-GB', {
    timeZone: 'Asia/Kolkata',
    hour: '2-digit',
    minute: '2-digit',
    hour12: false,
  } as Intl.DateTimeFormatOptions).formatToParts(new Date(iso));
  const hourValue = Number(parts.find((part) => part.type === 'hour')?.value ?? 0);
  const hour = hourValue === 24 ? 0 : hourValue;
  const minute = Number(parts.find((part) => part.type === 'minute')?.value ?? 0);
  return hour * 60 + minute;
}

export function bookLaterSlotsToTimeSlotView(
  slots: {startsAt: string}[],
  slotStartsIndex?: Map<number, string>,
): TimeSlotViewModel {
  if (slotStartsIndex) {
    slotStartsIndex.clear();
  }
  const morningTimeSlot: TimeSlotModel[] = [];
  const afternoonTimeSlot: TimeSlotModel[] = [];
  const eveningTimeSlot: TimeSlotModel[] = [];
  for (const slot of slots) {
    const minutes = minutesInIndia(slot.startsAt);
    slotStartsIndex?.set(minutes, slot.startsAt);
    const item: TimeSlotModel = {
      label: new Date(slot.startsAt).toLocaleTimeString('en-IN', {
        hour: 'numeric',
        minute: '2-digit',
        timeZone: 'Asia/Kolkata',
      }),
      minutes,
      status: 'available',
    };
    if (minutes < 12 * 60) {
      morningTimeSlot.push(item);
    } else if (minutes < 17 * 60) {
      afternoonTimeSlot.push(item);
    } else {
      eveningTimeSlot.push(item);
    }
  }
  return {morningTimeSlot, afternoonTimeSlot, eveningTimeSlot};
}

export const emptyTimeSlotView: TimeSlotViewModel = {
  morningTimeSlot: [],
  afternoonTimeSlot: [],
  eveningTimeSlot: [],
};
